module.exports = "/images/ce.png?63a24032b13f86e740244b5308de9e9b";